import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TemplateGallery from './TemplateGallery';

/**
 * "New from template" entry point for dashboards and sidebars (BBD-106).
 * Opens the gallery, then sends the user to the create page with
 * `?template=<ref>`, where useTemplatePrefill takes over (fields, render,
 * kit creation). When the user is already on that create page the template
 * is handed over with a window event instead, so the page is not re-entered
 * (which would trip the unsaved-changes guard) and the same template can be
 * chosen twice in a row.
 *
 * Props: createPath (e.g. "/create" or "/workspace/acme/create/document"),
 * workspaceId (optional), className, children (button label).
 */
const NewFromTemplateButton = ({ createPath = '/create', workspaceId = null, className = '', title = 'Start a new document from a template', children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const samePath = (a, b) => a.replace(/\/+$/, '') === b.replace(/\/+$/, '');

    return (
        <>
            <button type="button" className={className} onClick={() => setOpen(true)} title={title}>
                {children || (<><i className="fas fa-puzzle-piece"></i><span>Templates</span></>)}
            </button>
            <TemplateGallery
                isOpen={open}
                onClose={() => setOpen(false)}
                workspaceId={workspaceId}
                onChoose={(template) => {
                    setOpen(false);
                    if (samePath(location.pathname, createPath)) {
                        window.dispatchEvent(new CustomEvent('bb:apply-template', { detail: { template } }));
                    } else {
                        navigate(`${createPath}?template=${encodeURIComponent(template.ref)}`);
                    }
                }}
            />
        </>
    );
};

export default NewFromTemplateButton;
